import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProject, fetchPartnerCategoriesByBusinessUnit, addProjectPartnerCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProjectPartnerCategoryAddPage() {
  const { businessDomainId, businessUnitId, projectId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`;

  const [available, setAvailable] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [project, all] = await Promise.all([fetchProject(projectId), fetchPartnerCategoriesByBusinessUnit(businessUnitId)]);
        const assigned = new Set((project.associatedPartnerCategories || []).map((c) => c.partnerCategoryId));
        setAvailable((Array.isArray(all) ? all : []).filter((c) => !assigned.has(c.partnerCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, businessUnitId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) { notify.error(t("common.selectRequired")); return; }
    try {
      await addProjectPartnerCategory(projectId, selectedId);
      notify.success(t("message.create.success"));
      navigate(`${basePath}/partner-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("project.partnerCategory.add.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("partnerCategory.name")}</InputLabel>
              <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)} label={t("partnerCategory.name")}>
                {available.map((c) => (
                  <MenuItem key={c.partnerCategoryId} value={c.partnerCategoryId}>{c.partnerCategoryName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/projects/${projectId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
